import jsonapiClient from './lib/ra-jsonapi-client';

const url = `${process.env.REACT_APP_PROTOCOL || 'https'}://${process.env.REACT_APP_API_URL}`;

export default jsonapiClient(url, {
  resources: {
    users: {
      // platform refuses temporary_password without a new password, so the record's own value is never
      // sent back. Set Temporary Password (src/components/TemporaryPasswordDialog.js) sends
      // issue_temporary_password, with the password
      read_only: ['temporary_password'],
      write_as: {
        issue_temporary_password: 'temporary_password',
      },
      // platform adds a new user to the organization it is given as current_organization_id
      create_query_as: {
        organization_id: 'current_organization_id',
      },
    },
  },
});
